<template>
  <v-layout class="d-block px-1 mt-10">
    <v-row xs3 class="d-flex align-center mb-5" no-gutters>
      <h3 class="ma-0">Clinic opening overrides</h3>
        <v-tooltip top>
            <template v-slot:activator="{ on }">
                <p style="margin-left: 10px; margin-bottom: 0"><v-icon color="grey" dark v-on="on">mdi-information</v-icon></p>
            </template>
            <p class="tooltip-fixed">Create future changes to normal schedule, such as holidays, here.</p>
        </v-tooltip>
    </v-row>
    <v-sheet>
      <v-row class="d-flex align-center mb-5" no-gutters style="max-width: 700px">
        <v-menu
          v-model="fromDatePickerStatus"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              :value="Date.formatDate([dateFrom])"
              label="From"
              prepend-icon="mdi-calendar"
              readonly
              v-on="on"
              max-width="100px"
            ></v-text-field>
          </template>
          <v-date-picker first-day-of-week="1" v-model="dateFrom" @input="fromDatePickerStatus = false"></v-date-picker>
        </v-menu>
        <v-menu
          v-model="toDatePickerStatus"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              :value="Date.formatDate([dateTo])"
              label="To"
              prepend-icon="mdi-calendar"
              readonly
              v-on="on"
            ></v-text-field>
          </template>
          <v-date-picker first-day-of-week="1" v-model="dateTo" @input="toDatePickerStatus = false"></v-date-picker>
        </v-menu>
        <v-btn @click="filterOverrideDays" class="ml-5" :loading="dataLoading" :disabled="dataLoading">
          filter
        </v-btn>
      </v-row>
    </v-sheet>
    <v-row class="mt-4" no-gutters v-if="openingDaysOverride.length > 0">
      <v-simple-table>
        <template v-slot:default>
          <thead>
          <tr>
            <th class="text-left">Date</th>
            <th class="text-left">Day</th>
            <th class="text-center" colspan="2">Clinic</th>
            <th class="text-center" colspan="2" v-for="surgery in activeSurgeries" :key="surgery.id">
              {{surgery.value}}
            </th>
            <th></th>
          </tr>
          <tr>
            <th class="text-left"></th>
            <th class="text-center"></th>
            <th class="text-center" colspan="2">
              <div class="d-flex justify-space-between">
                <div class="px-2">AM</div>
                <div class="px-2">PM</div>
              </div>
            </th>
            <th class="text-center" colspan="2" v-for="(surgery, i) in activeSurgeries" :key="i">
              <div class="d-flex justify-space-between">
                <div class="px-2">AM</div>
                <div class="px-2">PM</div>
              </div>
            </th>
            <th class="text-center"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="day in overrideData" :key="day.uuid" :class="{
              'green lighten-5': day.isNew,
              'old-date': isOldDay(day.date)
            }">
            <td class="text-left">{{Date.formatDate([day.date])}}</td>
            <td class="text-left">{{day.dayName}}</td>
            <td class="text-center" colspan="2">
              <div class="d-flex justify-space-between">

                <action-btn v-if="day.clinic.am" v-on:change="dayClickHandler(day, 'clinic', 'am')" :isOpen="day.clinic.am.isOpen" :isChanged="day.clinic.am.changed"></action-btn>
                <action-btn v-else :noData="true" v-on:change="overrideClinicNoneHandler(day.clinic, day.date, 'am')"></action-btn>
                <action-btn v-if="day.clinic.pm" v-on:change="dayClickHandler(day, 'clinic', 'pm')" :isOpen="day.clinic.pm.isOpen" :isChanged="day.clinic.pm.changed"></action-btn>
                <action-btn v-else :noData="true" v-on:change="overrideClinicNoneHandler(day.clinic, day.date, 'pm')"></action-btn>
              </div>
            </td>
            <td class="text-center" colspan="2" v-for="(surgery, i) in activeSurgeries" :key="i">
              <div class="d-flex justify-space-between">
                <action-btn v-if="getCorrectSurgery(day.uuid, surgery).am" v-on:change="dayClickHandler(day, 'surgery', 'am', getCorrectSurgery(day.uuid, surgery).id)" :isOpen="getCorrectSurgery(day.uuid, surgery).am.isOpen" :isChanged="getCorrectSurgery(day.uuid, surgery).am.changed"></action-btn>
                <action-btn v-else :noData="true" v-on:change="overrideSurgeryNoneHandler(surgery, day, 'surgery', 'am', getCorrectSurgery(day.uuid, surgery).id)"></action-btn>
                <action-btn v-if="getCorrectSurgery(day.uuid, surgery).pm" v-on:change="dayClickHandler(day, 'surgery', 'pm', getCorrectSurgery(day.uuid, surgery).id)" :isOpen="getCorrectSurgery(day.uuid, surgery).pm.isOpen" :isChanged="getCorrectSurgery(day.uuid, surgery).pm.changed"></action-btn>
                <action-btn v-else :noData="true" v-on:change="overrideSurgeryNoneHandler(surgery, day, 'surgery', 'pm', getCorrectSurgery(day.uuid, surgery).id)"></action-btn>
              </div>
            </td>
            <td>
              <v-btn v-if="!Date.checkIsPastDate(day.date)" icon small @click="removeOpeningDayOverride(day.date)">
                <v-icon>mdi-delete</v-icon>
              </v-btn>
            </td>
          </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-row>
    <v-card class="pa-5 text-center" v-else>
      <b>No data for chosen dates</b>
    </v-card>
    <div class="mt-5">
      <v-pagination v-if="pageCount > 1" v-model="page" :length="pageCount"></v-pagination>
    </div>
    <div class="d-flex mt-5" style="max-width: 350px;">
      <v-menu
        v-model="addDatePickerStatus"
        :close-on-content-click="false"
        transition="scale-transition"
        offset-y
        min-width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            :value="Date.formatDate([newOverrideDate])"
            label="Enter date"
            prepend-icon="mdi-calendar"
            readonly
            :error-messages="newOverrideDateErrorMessages"
            v-on="on"
          ></v-text-field>
        </template>
        <v-date-picker first-day-of-week="1" v-model="newOverrideDate" @input="addDatePickerStatus = false"></v-date-picker>
      </v-menu>
      <v-btn @click="addOverride" class="mt-5 ml-5">
        ADD
      </v-btn>
    </div>
  </v-layout>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import { getDayName } from '@/common/date'
  import { sortBy } from 'lodash'
  import ActionBtn from './ActionBtn'

  const month = new Date().getMonth()
  const dateFrom = new Date()
  dateFrom.setMonth(month - 1)
  const dateTo = new Date()
  dateTo.setMonth(month + 12)

  const designators = ['am', 'pm']

  export default {
    name: 'DefaultOpeningDays',
    props: ['clinicId', 'surgeries'],
    data: () => ({
      dataLoading: false,
      openingDaysOverride: [],
      dateToDelete: [],
      newOverrideDate: '',
      addDatePickerStatus: false,
      fromDatePickerStatus: false,
      toDatePickerStatus: false,
      newOverrideDateErrorMessages: '',
      dateFrom: dateFrom.toISOString().substr(0, 10),
      dateTo: dateTo.toISOString().substr(0, 10),
      page: 1,
      limit: 10
    }),
    computed: {
      ...mapGetters(['getClinicOpeningOverride']),
      pageCount () {
        return Math.ceil(this.openingDaysOverride.length / this.limit)
      },
      overrideData () {
        const start = (this.page - 1) * this.limit
        const end = this.limit * this.page
        return sortBy(this.openingDaysOverride.concat().slice(start, end), 'date')
      },
      activeSurgeries () {
        const activeSurgeries = Object.keys(this.overrideData[0].surgeries).map(surgeryId => {
          return this.$store.getters.getSurgeryById(this.clinicId, surgeryId)
        })

        return sortBy(activeSurgeries, 'value')
      }
    },
    methods: {
      ...mapActions(['updateClinicOverrideDays', 'fetchClinicOverrideDays', 'deleteClinicOverrides']),
      getCorrectSurgery (dayId, surgery) {
        const overrideDay = this.overrideData.find(item => item.uuid === dayId)
        const key = Object.keys(overrideDay.surgeries).find(item => Number(item) === surgery.id)
        return overrideDay.surgeries[key]
      },
      dayClickHandler (item, type, designator, surgeryId) {
        if (type === 'clinic') {
          item[type][designator].isOpen = !item[type][designator].isOpen
          if (!item[type][designator].isOpen) {
            Object.values(item.surgeries).forEach(surgery => {
              surgery[designator].changed = true
            })
          }
          item[type][designator].changed = true
        } else {
          const surgery = item.surgeries[surgeryId][designator]
          surgery.isOpen = !surgery.isOpen
          item.clinic[designator].isOpen = surgery.isOpen
          surgery.changed = true
        }
      },
        overrideClinicNoneHandler (clinic, date, type) {
            clinic[type] = this.createOverrideDataItem(date, null, type)
            clinic[type].changed = true
        },
        overrideSurgeryNoneHandler (surgery, item, type, designator, surgeryId) {
            item.surgeries[surgeryId][designator] = this.createOverrideDataItem(item.date, surgeryId, designator)
            this.dayClickHandler(item, type, designator, surgeryId)
        },
      async filterOverrideDays () {
        this.fetchOverrideData()
      },
      async fetchOverrideData () {
        this.dataLoading = true
        await this.fetchClinicOverrideDays({
          clinicId: this.clinicId,
          from: new Date(this.dateFrom).toISOString().substr(0, 10),
          to: new Date(this.dateTo).toISOString().substr(0, 10)
        })
        this.createOverrideData()
        this.dataLoading = false
      },
      async createOverrideData (results = [], surgeries = this.surgeries) {
        results = this.getClinicOpeningOverride()
        if (results.length === 0) {
          return false
        }
        const allDateArray = results.reduce((acc, result) => {
          const date = result.date.substr(0, 10)
          if (!acc.includes(date) && date !== new Date().toISOString().substr(0, 10)) {
            acc.push(date)
          }
          return acc
        }, [])
        const groupByDate = results.reduce((acc, result) => {
          const date = result.date.substr(0, 10)
          if (acc[date]) {
            acc[date].push(result)
          } else {
            acc[date] = [result]
          }
          return acc
        }, {})
        this.openingDaysOverride = allDateArray.map(date => {
          const opDataItem = {}
          const clinicInfo = {
            am: groupByDate[date].find((result) => {
              return !result.surgeryId && result.designator.toLowerCase() === 'am'
            }),
            pm: groupByDate[date].find((result) => {
              return !result.surgeryId && result.designator.toLowerCase() === 'pm'
            })
          }
          const surgeriesInfo = surgeries.reduce((acc, surgery) => {
            acc[surgery.id] = {
              am: groupByDate[date].find((result) => {
                return result.surgeryId === surgery.id && result.designator.toLowerCase() === 'am'
              }),
              pm: groupByDate[date].find((result) => {
                return result.surgeryId === surgery.id && result.designator.toLowerCase() === 'pm'
              }),
              id: surgery.id
            }
            return acc
          }, {})

          opDataItem.uuid = this.$uuid.v1()
          opDataItem.date = date
          opDataItem.dayName = getDayName(date)
          opDataItem.clinic = clinicInfo
          opDataItem.surgeries = surgeriesInfo
          return opDataItem
        })
      },
      createOverrideDataItem (date, surgeryId, designator, isOpen = true) {
        return {
          date,
          designator: designator.toUpperCase(),
          clinicId: this.clinicId,
          surgeryId,
          isOpen
        }
      },
      removeOpeningDayOverride (date) {
        this.dateToDelete.push({
          clinicId: this.clinicId,
          date
        })
        this.openingDaysOverride = this.openingDaysOverride.filter(item => item.date !== date)
      },
      addOverride () {
        this.newOverrideDateErrorMessages = ''
        if (this.newOverrideDate.length < 1) {
          this.newOverrideDateErrorMessages = 'Date is required!'
          return
        }
        const newDate = new Date(this.newOverrideDate).toISOString().substr(0, 10)
        // if (Date.checkIsPastDate(this.newOverrideDate)) {
        //   this.newOverrideDateErrorMessages = 'Date should not be earlier then today!'
        //   return
        // }
        if (Date.checkIsLessThanTomorrow(this.newOverrideDate)) {
          this.newOverrideDateErrorMessages = 'Date should not be earlier then tomorrow!'
          return
        }
        if (this.openingDaysOverride.find(item => item.date === newDate)) {
          this.newOverrideDateErrorMessages = 'Date is already exist!'
          return
        }
        const newOverride = {
          uuid: this.$uuid.v1(),
          isNew: true,
          date: newDate,
          dayName: getDayName(newDate),
          clinic: {
            am: this.createOverrideDataItem(newDate, null, 'am'),
            pm: this.createOverrideDataItem(newDate, null, 'pm')
          },
          surgeries: this.surgeries.reduce((acc, surgery) => {
            acc[surgery.id] = {
              am: this.createOverrideDataItem(newDate, surgery.id, 'am'),
              pm: this.createOverrideDataItem(newDate, surgery.id, 'pm'),
              id: surgery.id
            }
            return acc
          }, {})
        }
        this.openingDaysOverride.push(newOverride)
        this.page = this.pageCount
      },
      createOverrideFormData () {
        return this.openingDaysOverride.reduce((acc, day) => {
          designators.forEach(designator => {
            const clinicDayPart = day.clinic[designator]
            if (day.isNew || (clinicDayPart && clinicDayPart.changed)) {
              clinicDayPart.clinicId = this.clinicId
              clinicDayPart.surgeryId = null
              acc.push(clinicDayPart)
            }
          })
          for (const value of Object.values(day.surgeries)) {
            designators.forEach(designator => {
              const surgeryDayPart = value[designator]
              if (day.isNew || (surgeryDayPart && surgeryDayPart.changed)) {
                surgeryDayPart.surgeryId = value.id
                surgeryDayPart.clinicId = this.clinicId
                acc.push(surgeryDayPart)
              }
            })
          }
          return acc
        }, [])
      },
      async saveOverrideData () {
        const formData = this.createOverrideFormData()
        if (this.dateToDelete.length > 0) {
          this.deleteClinicOverrides({
            days: this.dateToDelete
          })
        }
        if (formData.length > 0) {
          return this.updateClinicOverrideDays({
            days: formData
          })
        }
        return true
      },
      isOldDay (date) {
        const targetDate = new Date(date).getTime()
        const today = new Date().getTime()
        return today > targetDate
      }
    },
    components: {
      ActionBtn
    }
  }
</script>

<style lang="scss">
  .old-date {
    opacity: 0.5;
    pointer-events: none;
  }
</style>
